import React from 'react';
import { ConfigSettingsDataTable } from '@/shared/components/config-settings';
import type { DealerConfigSetting } from '../types/dealerConfig.types';
import type { useDealerConfigSettingMutations } from '../hooks/useDealerConfigSettingMutations';

interface Props {
    data: DealerConfigSetting[];
    mutations: ReturnType<typeof useDealerConfigSettingMutations>;
}

// Dealer groups are a free string (Epic 7.1.4 Decision 4), so no groupOrder is passed:
// the engine default sorts alphabetically with Uncategorised last.
const groupLabel = (s: DealerConfigSetting): string => s.configOption?.group ?? 'Uncategorised';

// Duplicate keys are allowed per dealer (no unique(dealer_id, key) constraint), so no
// repeatableKeys: the engine's duplicate-count addressing covers it.
const PERMISSIONS = {
    edit: { resource: 'dealer', action: 'config-setting.edit' },
    delete: { resource: 'dealer', action: 'config-setting.delete' },
} as const;

export const DealerConfigSettingDataTable: React.FC<Props> = ({ data, mutations }) => (
    <ConfigSettingsDataTable<DealerConfigSetting>
        data={data}
        mutations={mutations}
        permissions={PERMISSIONS}
        entityNoun="dealer"
        groupLabel={groupLabel}
    />
);
